import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7e7bb12d")

_pushScopeId("data-v-7e7bb12d")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "spinnerWrapper"
}
const _hoisted_3 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_ExpandableClass = _resolveComponent("ExpandableClass", true)

  return (_openBlock(), _createBlock("li", null, [
    _createVNode(_component_Tooltip, {
      text: `${_ctx.classData.iri}\nEndpunkte:\n${Array.from(_ctx.classData.getEndpoints()).join('\n')}`
    }, {
      default: _withId(() => [
        _createVNode("label", null, [
          _createVNode("span", {
            class: ["material-icons arrow-right", {unfolded: _ctx.unfolded, disabled: !_ctx.classData.hasSubclasses}],
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleUnfold()))
          }, "chevron_right", 2),
          _createVNode("span", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateSelected(_ctx.classData.iri))),
            class: {selected: _ctx.isSelected}
          }, [
            _createTextVNode(_toDisplayString(_ctx.classData.label) + " ", 1),
            (_ctx.classData.elementCount!=null)
              ? (_openBlock(), _createBlock("span", _hoisted_1, "(" + _toDisplayString(_ctx.classData.elementCount) + ")", 1))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      _: 1
    }, 8, ["text"]),
    (_ctx.unfolded)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (_ctx.fetching)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_LoadingSpinner)
              ]))
            : (_openBlock(), _createBlock("ul", _hoisted_3, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subclasses, (c) => {
                  return (_openBlock(), _createBlock(_component_ExpandableClass, {
                    key: c.iri,
                    classData: c,
                    modelValue: _ctx.subclass,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.subclass = $event)),
                    onHierarchyUpdate: _ctx.passHierarchyUpdate,
                    depth: _ctx.depth + 1
                  }, null, 8, ["classData", "modelValue", "onHierarchyUpdate", "depth"]))
                }), 128))
              ]))
        ], 64))
      : _createCommentVNode("", true)
  ]))
})